import { lazy } from 'react';

export const Main = lazy(() => import('./Main.components'));
